import { render, staticRenderFns } from "./TicketLayout.vue?vue&type=template&id=c6ec2170&scoped=true&"
import script from "./TicketLayout.vue?vue&type=script&lang=js&"
export * from "./TicketLayout.vue?vue&type=script&lang=js&"
import style0 from "./TicketLayout.vue?vue&type=style&index=0&id=c6ec2170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ec2170",
  null
  
)

export default component.exports